import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PenaltyFeeService {

    indexId: number = 0;
    
}